export const FETCH_TOTAL_ANALYTICS = 'ANALYTICS/FETCH_TOTAL_ANALYTICS';
export const FETCH_TOTAL_ANALYTICS_ERROR = 'ANALYTICS/FETCH_TOTAL_ANALYTICS_ERROR';
export const CLEAR_TOTAL_ANALYTICS = 'ANALYTICS/CLEAR_TOTAL_ANALYTICS';

export const FETCH_DAY_BY_DAY_ANALYTICS = 'ANALYTICS/FETCH_DAY_BY_DAY_ANALYTICS';
export const FETCH_DAY_BY_DAY_ANALYTICS_ERROR = 'ANALYTICS/FETCH_DAY_BY_DAY_ANALYTICS_ERROR';
export const CLEAR_DAY_BY_DAY_ANALYTICS = 'ANALYTICS/CLEAR_DAY_BY_DAY_ANALYTICS';

export const FETCH_TOP_LINKS = 'ANALYTICS/FETCH_TOP_LINKS';
export const FETCH_TOP_LINKS_ERROR = 'ANALYTICS/FETCH_TOP_LINKS_ERROR';
export const CLEAR_TOP_LINKS = 'ANALYTICS/CLEAR_TOP_LINKS';

export const FETCH_TOP_LINK_DETAILS = 'ANALYTICS/FETCH_TOP_LINK_DETAILS';
export const FETCH_TOP_LINK_DETAILS_ERROR = 'ANALYTICS/FETCH_TOP_LINK_DETAILS_ERROR';
export const CLEAR_TOP_LINK_DETAILS = 'ANALYTICS/CLEAR_TOP_LINK_DETAILS';

export const FETCH_DEVICE_CATEGORIES = 'ANALYTICS/FETCH_DEVICE_CATEGORIES';
export const FETCH_DEVICE_CATEGORIES_ERROR = 'ANALYTICS/FETCH_DEVICE_CATEGORIES_ERROR';
export const CLEAR_DEVICE_CATEGORIES = 'ANALYTICS/CLEAR_DEVICE_CATEGORIES';

export const FETCH_MOBILE_DEVICES = 'ANALYTICS/FETCH_MOBILE_DEVICES';
export const FETCH_MOBILE_DEVICES_ERROR = 'ANALYTICS/FETCH_MOBILE_DEVICES_ERROR';
export const CLEAR_MOBILE_DEVICES = 'ANALYTICS/CLEAR_MOBILE_DEVICES';

export const FETCH_AUDIENCE_BY_COUNTRY = 'ANALYTICS/FETCH_AUDIENCE_BY_COUNTRY';
export const FETCH_AUDIENCE_BY_COUNTRY_ERROR = 'ANALYTICS/FETCH_AUDIENCE_BY_COUNTRY_ERROR';
export const CLEAR_AUDIENCE_BY_COUNTRY = 'ANALYTICS/CLEAR_AUDIENCE_BY_COUNTRY';

export const FETCH_AUDIENCE_BY_GLOBAL_MARKET = 'ANALYTICS/FETCH_AUDIENCE_BY_GLOBAL_MARKET';
export const FETCH_AUDIENCE_BY_GLOBAL_MARKET_ERROR = 'ANALYTICS/FETCH_AUDIENCE_BY_GLOBAL_MARKET_ERROR';
export const CLEAR_AUDIENCE_BY_GLOBAL_MARKET = 'ANALYTICS/CLEAR_AUDIENCE_BY_GLOBAL_MARKET';

export const FETCH_AUDIENCE_BY_CITY = 'ANALYTICS/FETCH_AUDIENCE_BY_CITY';
export const FETCH_AUDIENCE_BY_CITY_ERROR = 'ANALYTICS/FETCH_AUDIENCE_BY_CITY_ERROR';
export const CLEAR_AUDIENCE_BY_CITY = 'ANALYTICS/CLEAR_AUDIENCE_BY_CITY';

export const FETCH_REFERRERS = 'ANALYTICS/FETCH_REFERRERS';
export const FETCH_REFERRERS_ERROR = 'ANALYTICS/FETCH_REFERRERS_ERROR';
export const CLEAR_REFERRERS = 'ANALYTICS/CLEAR_REFERRERS';

export const FETCH_TOP_LINKS_CSV = 'ANONYMOUS-MESSAGES/FETCH_TOP_LINKS_CSV';
export const FETCH_TOP_LINKS_CSV_ERROR = 'ANONYMOUS-MESSAGES/FETCH_TOP_LINKS_CSV_ERROR';
export const CLEAR_FETCH_TOP_LINKS_CSV = 'ANONYMOUS-MESSAGES/CLEAR_FETCH_TOP_LINKS_CSV';

export const FETCH_REFERRERS_CSV = 'ANONYMOUS-MESSAGES/FETCH_REFERRERS_CSV';
export const FETCH_REFERRERS_CSV_ERROR = 'ANONYMOUS-MESSAGES/FETCH_REFERRERS_CSV_ERROR';
export const CLEAR_FETCH_REFERRERS_CSV = 'ANONYMOUS-MESSAGES/CLEAR_FETCH_REFERRERS_CSV';
